import { Component, Inject, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { FileReaderEvent } from '../../../../../shared/models/FileReader';
import { EditImageDialogEditformsComponent } from '../../../edit-digital-forms/edit-image-dialog-editforms/edit-image-dialog-editforms.component';
import { SetupImplementService } from '../../../setup-implement/setup-implement.service';
import { CrackObPointImagesVM, NormalObsPointHistroy } from '../../equipment-details.model';
import { ViewObsHistoryPhotoDialogComponent } from './view-obs-history-photo-dialog/view-obs-history-photo-dialog.component';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-obspoint-action-histroy',
  templateUrl: './obspoint-action-histroy.component.html',
  styleUrls: ['./obspoint-action-histroy.component.scss']
})
export class ObspointActionHistroyComponent implements OnInit {
  CompName:string;
  ObsName:string;
  componentId:number;
  obId:number;
  historyList:NormalObsPointHistroy[];
isCrack:boolean=false;

implementId:number;
GETEventId:number;

  constructor(private _dialogRef: MatDialogRef<ObspointActionHistroyComponent>, 
    @Inject(MAT_DIALOG_DATA) private _data: any, public _implementService: SetupImplementService,
    private _notify: NotificationsService, private _dialog: MatDialog,
    ) { }

  ngOnInit() {
    console.log("data__", this._data)
    this.CompName=this._data.CompName;
    this.ObsName =this._data.ObsName;
    this.componentId=this._data.componentId;
    this.obId=this._data.obId;
    this.isCrack=this._data.isCrack;
    this.historyList=[];

    this.GETEventId=this._data.GETEventId;
    this.implementId=this._data.implementId;

 

    if(this.obId>0 && this.componentId>0 && this.isCrack==false){
      this.openHistroyDate();
    }else if(this.obId>0 && this.componentId>0 && this.isCrack==true){
      this.openCrackHistory();  
    }else{
      this.openReplacementInfoHistory();
    }
  }

  openCrackHistory(){
    this._implementService.LoadCrackObsPointHistroy(this.componentId,this.obId).subscribe(result=>{
      this.historyList =result;
    })
    
  }
  getValue(obs: any): number {
    return obs.Worn?.toFixed(1) >= 100 ? 0 : obs.Residual;
  }
  openHistroyDate(){
    this._implementService.LoadNormalObsPointHistroy(this.componentId,this.obId).subscribe(result=>{
      this.historyList =result;
    })
  }

  ActionDate:Date =  new Date();
  openReplacementInfoHistory(){
    this._implementService.LoadReplaceRepairComponent(this.implementId,this.GETEventId).subscribe(result=>{
      this.historyList =result;
      if(this.historyList.length>0){
        this.ActionDate = this.historyList[0].actionDate;
      }
    })
    
  }

  onNoClick(){
    this._dialogRef.close(false);
  }

  onSelectPhoto(event: any, Action, Id, ObsPointHxId) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        const imageUrl = (event.target["result"]);
        //resize photo
        this.compressImage(imageUrl).then((res: string) => {
          // console.log("imageUrl", res)
          if (res) {
           //console.log('res', res)
  
            //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
            this.uploadPhoto(res.split(',')[1], Action, Id,ObsPointHxId);
          }
        })
        //this.uploadPhoto(event.target.result.split(',')[1]);
      };
    }
  }

  private compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
  
  
  
  
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');
  
        let width, height;
        width = img.width;
        height = img.height;
  
        console.log('width', width)
        console.log('height', height)
  
        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height
  
  
        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }

  uploadPhoto(newPhoto: string,Action, Id,ObsPointHxId){
    let params= new CrackObPointImagesVM()
    // if(Action=="Inspection"){
    //   params.crackStatusHistoryID=null
    //   params.observationInspectinId=Id
    //   params.IsHistory=false
    //   params.image=newPhoto
    // }
    
    // else if(Action=="Crack Modified"){
    //   params.crackStatusHistoryID=Id
    //   params.observationInspectinId=null
    //   params.IsHistory=true
    //   params.image=newPhoto
    // }

      if(Action=="Inspection - Crack Modified" || Action=="Inspection - Crack Created"){
      params.crackStatusHistoryID=ObsPointHxId
      params.observationInspectinId=Id
      params.IsHistory=false
      params.image=newPhoto
    }
    this._implementService.saveCrackObservationPointImages(params).subscribe(res=>{
      this._notify.success("Image has been successfully Uploaded");
      this.openCrackHistory()
    })
  }

 


  openViewPhoto(photo: CrackObPointImagesVM){
    const dialogRef = this._dialog.open(ViewObsHistoryPhotoDialogComponent, {
      data: {
        
        image: photo.image,
        Id:photo.Id
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      this.openCrackHistory()
    });
      

  }
}
